export const SITE_URL = 'https://www.eclipsegroup.in';

export interface Crumb {
  name: string;
  path: string;
}

const HOME: Crumb = { name: 'Home', path: '/' };

export const absoluteUrl = (path: string): string => (path === '/' ? `${SITE_URL}/` : `${SITE_URL}${path}`);

// Home first, then the given trail with the current page last.
export const withHome = (trail: Crumb[]): Crumb[] => [HOME, ...trail];

export function breadcrumbListSchema(crumbs: Crumb[]) {
  const current = crumbs[crumbs.length - 1];
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    '@id': `${absoluteUrl(current.path)}#breadcrumb`,
    itemListElement: crumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.name,
      item: absoluteUrl(crumb.path),
    })),
  };
}

// JSON.stringify leaves "<" alone, so a name containing "</script>" would end
// the tag early. The escaped form parses to the same JSON.
export const toJsonLd = (data: unknown): string => JSON.stringify(data).replace(/</g, '\\u003c');
